<template>
    <div>
        <loading :active.sync="is_loading" 
        :can-cancel="true" 
        :is-full-page="true">
        </loading>
        <!-- Navbar -->
        <Navbar/>

        <!-- Sidebar -->
        <SidebarSpatial/>

        <main id="main" class="main">
            <!-- Breadcomp -->
            <Breadcrumb :links="links"/>
            <!-- END OF BREADCOMP -->

            <section class="section pt-0">
                <div class="row">
                    <!-- Left side columns -->
                    <div class="col-lg-9 position-relative">
                        <div class="bg-white w-100 position-absolute start-0 top-0 p-3 overflow-auto" :class="show_station_detail ? 'd-block':'d-none'" style="height: 800px; z-index: 10">
                            <h4 class="ps-3">{{ heading }}</h4>
                            <a href="" class="position-absolute" style="top: 15px; right: 20px" @click.prevent="show_station_detail = false">
                                <i class="fa fa-times"></i>
                            </a>
                            <div class="clearfix"></div>
                            <div class="border-top ps-3">
                                <div class="my-3">
                                    <div class="row">
                                        <div class="col-md-4">
                                            Start Date
                                        </div>
                                        <div class="col-md-4">
                                            End Date
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <input type="date" class="form-control" v-model="startDate">
                                        </div>
                                        <div class="col-md-2">
                                            <vue-timepicker input-class="form-control" format="HH:mm" :minute-interval="10" v-model="startTime"></vue-timepicker>
                                        </div>
                                        <div class="col-md-2">
                                            <input type="date" class="form-control" v-model="endDate">
                                        </div>
                                        <div class="col-md-2">
                                            <vue-timepicker input-class="form-control" format="HH:mm" :minute-interval="10" v-model="endTime"></vue-timepicker>
                                        </div>
                                        <div class="col-md-2">
                                            <button class="btn btn-primary" @click="getDataByDateTime"><i class="fa fa-filter"></i> Filter</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <line-chart :chart-data="chart_data" :height="300" :options="chart_options" v-if="show_station_detail"></line-chart>
                                </div>
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Tanggal</th>
                                            <th>{{ columnName }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="row in detail" :key="row.ymdhm">
                                            <td>{{ row.date }}</td>
                                            <td>{{ row.value }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="position-relative">
                            <GmapMap
                                :center="{lat:this.lat, lng:this.lng}"
                                :zoom="9"
                                map-type-id="terrain"
                                style="width: 100%; height: 800px"
                                ref="peta">
                            </GmapMap>
                            <div class="position-absolute bg-light p-3" style="width: 300px; z-index:9; right: 30px; bottom: 30px">
                                <h4>Legend</h4>
                                <a href="#" @click.prevent="toggleMarkers('wl_markers')" class="d-block id-bbr" :class="wl_markers_state ? 'marker-is-on':''">
                                    <img :src="require('../../assets/waterlevel.png')" /> Water Level
                                </a>
                                <a href="#" @click.prevent="toggleMarkers('rf_markers')" class="d-block id-bbr" :class="rf_markers_state ? 'marker-is-on':''">
                                    <img :src="require('../../assets/rainfall.png')" /> Rainfall
                                </a>
                                <a href="#" @click.prevent="toggleMarkers('db_markers')" class="d-block id-bbr" :class="db_markers_state ? 'marker-is-on':''">
                                    <img :src="require('../../assets/debit.png')" /> Debit
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <b-tabs>
                            <b-tab title="Ketinggian Air">
                                <div class="card">
                                    <div class="card-body" style="height: 760px; overflow: auto">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Stasiun Pengamatan</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="wl in water_level" :key="wl.wlobscd">
                                                    <td :class="wl.wlobscd === current_station_id ? 'selected':''">
                                                        <a href="" @click.prevent="getStationDetail('water-level', wl.wlobscd)">{{ wl.obsnm }}</a></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Curah Hujan">
                                <div class="card">
                                    <div class="card-body" style="height: 760px; overflow: auto">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Stasiun Pengamatan</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="rf in rainfall" :key="rf.rfobscd">
                                                    <td :class="rf.rfobscd === current_station_id ? 'selected':''">
                                                        <a href="" @click.prevent="getStationDetail('rainfall', rf.rfobscd)">{{ rf.obsnm }}</a></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Debit">
                                <div class="card">
                                    <div class="card-body" style="height: 760px; overflow: auto">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Stasiun Pengamatan</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="fw in debit" :key="fw.fwobscd">
                                                    <td :class="fw.fwobscd === current_station_id ? 'selected':''">
                                                        <a href="" @click.prevent="getStationDetail('debit', fw.fwobscd)">{{ fw.obsnm }}</a></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </section>
        </main>
        <!-- <input type="text" class="map-search" id="spatial-search" placeholder="Address Search"> -->
    </div>
</template>

<script>

    // import
    import axios from 'axios'
    import Loading from 'vue-loading-overlay'
    import Breadcrumb from '../../components/Breadcrumb.vue'
    import {BTabs, BTab} from 'bootstrap-vue';
    // import Notif from 'vue-notification' 

    // Component
    import Navbar from '../../components/Navbar.vue'
    import SidebarSpatial from '../../components/SidebarSpatial.vue'
    import { gmapApi } from 'vue2-google-maps'
    import 'bootstrap-icons/font/bootstrap-icons.css';
    import moment from 'moment';
    import LineChart from '../../components/chart/LineChart.vue'
    import VueTimepicker from 'vue2-timepicker'
    import 'vue2-timepicker/dist/VueTimepicker.css'
    // import draggable from 'vuedraggable'
    // import '../../maplabel.js'
    
    export default{
        components:{
            Navbar,
            SidebarSpatial,
            Loading, 
            Breadcrumb,
            BTab,
            BTabs,
            LineChart,
            VueTimepicker
        },
        data(){
            return{
                // Need
                is_loading: false,
                is_fullpage: true,
                token: null,
                lat: -6.5341128, 
                lng: 107.3428813,
                limit: 3,
                links: [
                    {url: '/dashboard', text:'Home'}, 
                    {url: '/spasial', text: 'Flood Forecasting and Warning System'}, 
                ],
                map: null,
                startDate: new Date().toISOString().split('T')[0],
                endDate: new Date().toISOString().split('T')[0],
                startTime: {
                    HH: '00',
                    mm: '00'
                },
                endTime: {
                    HH: String(new Date().getHours()).padStart(2, '0'),
                    mm: this.roundTimeToNext10Min()
                },
                wl_markers_state: true,
                wl_markers: [], // waterlevel
                rf_markers_state: true,
                rf_markers: [], // rainfall
                db_markers_state: true,
                db_markers: [], // debit
                random: Math.random(),
                water_level: [],
                rainfall: [],
                debit: [],
                show_station_detail: false,
                heading: '',
                columnName: '',
                detail: [],
                current_type: null,
                current_station_id: null,
                chart_options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            ticks: {
                                autoSkip: true,
                                maxTicksLimit: 6,
                                maxRotation: 0,
                                fontSize: 10
                            },
                            offset: false
                        }],
                        yAxes: [{
                            display: true,
                            position: "left",
                            id: "y-axis-1",
                            scaleLabel: {
                                display: true,
                                labelString: ""
                            }
                        }]
                    }
                },
                chart_data: {
                    labels: [],
                    datasets: []
                }
            }
        },
        mounted(){
            this.getStations();
        },
        methods: {
            roundTimeToNext10Min(date = new Date()) {
                let hours = date.getHours();
                let minutes = date.getMinutes();

                // Round UP to nearest 10
                let roundedMinutes = Math.ceil(minutes / 10) * 10;

                // Handle overflow
                if (roundedMinutes === 60) {
                    roundedMinutes = 0;
                    hours = (hours + 1) % 24; // wrap around at midnight
                }

                return {
                    HH: String(hours).padStart(2, '0'),
                    mm: String(roundedMinutes).padStart(2, '0'),
                };
            },
            async getStations(){
                this.is_loading = true;

                try {
                    const water_level = await axios.get(`${this.$endpoints.ffws}/water-level`, {
                        params: {
                            operation: 'station'
                        }
                    });

                    const rainfall = await axios.get(`${this.$endpoints.ffws}/rainfall`, {
                        params: {
                            operation: 'station'
                        }
                    });
                    const debit = await axios.get(`${this.$endpoints.ffws}/debit`, {
                        params: {
                            operation: 'station'
                        }
                    });

                    this.water_level = water_level.data;
                    this.rainfall = rainfall.data;
                    this.debit = debit.data;

                    this.$nextTick(() => {
                        this.$refs.peta.$mapPromise.then((map) => {
                            this.map = map;
                            
                            this.water_level.map(wl => {
                                let marker = new this.google.maps.Marker({
                                    position: new this.google.maps.LatLng(wl.lat, wl.lon),
                                    map: this.map,
                                    icon: require('../../assets/icon/waterlevel.png'),
                                    label: {
                                        text: wl.obsnm,
                                        className: 'label-marker'
                                    }
                                });

                                marker.addListener('click', () => {
                                    this.getStationDetail('water-level', wl.wlobscd);
                                });

                                this.wl_markers.push(marker);
                            });

                            this.rainfall.map(rf => {
                                let marker = new this.google.maps.Marker({
                                    position: new this.google.maps.LatLng(rf.lat, rf.lon),
                                    map: this.map,
                                    icon: require('../../assets/icon/rainfall.png'),
                                    label: {
                                        text: rf.obsnm,
                                        className: 'label-marker'
                                    },
                                });

                                marker.addListener('click', () => {
                                    this.getStationDetail('rainfall', rf.rfobscd);
                                });

                                this.rf_markers.push(marker);
                            });

                            this.debit.map(db => {
                                let marker = new this.google.maps.Marker({
                                    position: new this.google.maps.LatLng(db.lat, db.lon),
                                    map: this.map,
                                    icon: require('../../assets/icon/debit.png'),
                                    label: {
                                        text: db.obsnm,
                                        className: 'label-marker'
                                    }
                                });

                                marker.addListener('click', () => {
                                    this.getStationDetail('debit', db.fwobscd);
                                });

                                this.db_markers.push(marker);
                            });
                        });
                    });
                } catch (error) {
                    console.error(error);
                    this.$swal('Error', 'Kesalahan terjadi saat mengambil data', 'error');
                }

                this.is_loading = false;
            },
            getDataByDateTime(){
                let sdate = `${this.startDate} ${this.startTime.HH}:${this.startTime.mm}`;
                let edate = `${this.endDate} ${this.endTime.HH}:${this.endTime.mm}`;
                edate = moment(edate).format('YYYYMMDDHHmm');
                sdate = moment(sdate).format('YYYYMMDDHHmm');

                this.getStationDetail(this.current_type, this.current_station_id, sdate, edate);
                
            },
            async getStationDetail(type, station_id, start_date = undefined, end_date = undefined){
                this.show_station_detail = true;
                this.is_loading = true;
                this.current_type = type;
                this.current_station_id = station_id;
                this.detail = [];
                this.chart_data = {
                    labels: [],
                    datasets: []
                };

                const map = {
                    'water-level': 'Ketinggian Air',
                    'rainfall': 'Curah Hujan',
                    'debit': 'Debit Air'
                };

                const uom = {
                    'water-level': '(m)',
                    'rainfall': '(mm)',
                    'debit': '(m3/s)'
                };

                const startDate = start_date ? start_date:moment().format('YYYYMMDD0000');
                const endDate = end_date ? end_date:moment().format('YYYYMMDDHH00');

                // reset start date dan end date kalau fungsi dipanggil dari daftar lokasi sebelah kanan
                if(typeof start_date === 'undefined'){
                    this.startDate = new Date().toISOString().split('T')[0];
                    this.startTime = {
                        HH: '00',
                        mm: '00'
                    };
                }

                if(typeof end_date === 'undefined'){
                    this.endDate = new Date().toISOString().split('T')[0];
                    this.endTime = this.roundTimeToNext10Min();
                }
                
                try {
                    const response = await axios.get(`${this.$endpoints.ffws}/${type}`, {
                        params: {
                            operation: 'data',
                            stationId: station_id,
                            startDate,
                            endDate,
                        }
                    });
                    
                    const station = this[type.replace('-', '_')].find(station => station.id === station_id);
                    
                    if(station){
                        this.heading = `${map[type]} - ${station.obsnm}`;
                        this.detail = response.data;
                        this.columnName = `${map[type]} ${uom[type]}`;

                        const datasets = [
                            {
                                type: type === 'rainfall' ? 'bar':'line',
                                label: map[type],
                                data: [], // Y-axis values
                                borderColor: 'blue',
                                backgroundColor: type === 'rainfall' ? 'rgba(0, 0, 255, 1)':'transparent',
                                borderWidth: 2,
                                barThickness: 3,
                                tension: 0 // bikin agak melengkung
                            }
                        ];
                        const labels = [];

                        this.detail.forEach(row => {
                            datasets[0].data.push(row.value);
                            labels.push(row.date);
                        });

                        this.chart_data = {
                            labels,
                            datasets
                        };

                        this.$set(this.chart_options.scales.xAxes[0], "offset", (type === 'rainfall'));
                        this.$set(this.chart_options.scales.yAxes[0].scaleLabel, "labelString", (type === 'water-level' ? 'Ketinggian Air (m)':(type === 'rainfall' ? 'Curah Hujan (mm)':(type === 'debit' ? 'Debit (m3/s)':''))));
                    }
                } catch (error) {
                    console.error(error);
                }

                this.is_loading = false;
            },
            toggleMarkers(group) {
                this[`${group}_state`] = !this[`${group}_state`];
                this[group].map(marker => {
                    if(this[`${group}_state`]){
                        marker.setMap(this.map);
                    }else{
                        marker.setMap(null);
                    }
                });
            }
        },
        computed: {
            google: gmapApi
        }
    }

</script>

<style>
    .card-header{
        cursor: pointer;
        font-size: 14px;
    }

    #spatial-map-legend{
        bottom: -5px;
        right: 60px;
        font-size: 12px;
    }

    #spatials{
        height: 400px;
        overflow: auto;
    }

    #spatials li a{
        font-size: 14px;
    }

    .spatial-symbol-poly {
        height: 10px;
        width: 10px;
    }

    .spatial-symbol-line {
        height: 2px;
        width: 10px;
    }

    .odd{
        background: #ddd;
    }

    .expanded{
        height: 490px;
        transition: height .3s;
    }

    .folded{
        height: 0;
        padding-top: 0!important;
        padding-bottom: 0!important;
        transition: height .3s;
    }

    .label-marker{
        color: #fff!important;
        margin-top: 20px!important;
        text-shadow:
            -1px -1px 0 #000,  
            1px -1px 0 #000,
            -1px 1px 0 #000,
            1px 1px 0 #000;
    }

    .map-search{
        background-color: #fff;
        padding: 3px 10px;
        width: 400px;
        font-family: Roboto;
        font-size: 15px;
        font-weight: 300;
        text-overflow: ellipsis;
        margin-top: 10px;
    }

    #search-result{
        max-height: 300px;
        overflow: auto;
        background: #fff;
        width: 400px;
    }

    #search-result ul{
        list-style-type: none;
        padding: 10px 0 0 0;
    }

    #search-result ul>li{
        padding: 5px 20px;
    }

    #search-result a{
        font-size: 14px;
    }

    .id-bbr{
        background-color: transparent;
        color: #000;
        padding: 5px;
        margin-bottom: 10px;
        border-radius: 10px;
        border: 1px solid #4499ff;
    }

    .id-bbr img{
        filter: invert(1);
        transition: filter 0.2s ease;
    }

    .marker-is-on{
        background-color: #4499ff;
        color: #fff!important;
        border: 1px solid transparent;
    }

    .marker-is-on img{
        filter: none;
    }

    .vue__time-picker input.display-time{
        height: auto;
        padding: 0.375rem 0.75rem!important;
    }

    td.selected{
        background-color:#495bf2!important;
    }

    td.selected a{
        color: #fff!important;
    }
</style>